/**
 * projectName 租户间稿库发出
 * createTime 2019-05-20
 * name zhang.yingyu
 */
angular.module("postTenantModule", ["postTenantLeftModule"])
    .controller("postTenantCtrl", ['$scope', '$q', '$modal', '$state', 'trsHttpService', 'modalDialog', 'trsspliceString', 'initSingleSelecet', 'resCtrModalService', '$stateParams', 'storageListenerService',
        function($scope, $q, $modal, $state, trsHttpService, modalDialog, trsspliceString, initSingleSelecet, resCtrModalService, $stateParams, storageListenerService) {
            initStatus();
            initData();
            /**
             * [initStatus 初始化状态]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.page = {
                    "CURRPAGE": 1,
                    "PAGESIZE": 20,
                    "ITEMCOUNT": 0,
                    "PAGECOUNT": 1,
                };
                $scope.status = {
                    copyCurrPage: 1,
                    tenantStatus: [{
                        name: "全部状态",
                        value: ""
                    }, {
                        name: "已共享",
                        value: 0
                    }, {
                        name: "撤稿",
                        value: 1
                    }, ],
                    id: $stateParams.id,
                };
                $scope.keywords = '';
                $scope.status.tenantStatusSelected = angular.copy($scope.status.tenantStatus[0]);
                $scope.iWoDocStatusName = initSingleSelecet.iWoDocType().filter((item) => {
                    return item.value != 9 && item.value != 11;
                });
                $scope.iWoDocStatusSelected = angular.copy($scope.iWoDocStatusName[0]);
                $scope.data = {
                    items: [],
                    selectedArray: []
                };
                $scope.params = {
                    serviceid: "mlf_PluralisticShare",
                    methodname: "sharedList",
                    type: '',
                    tenantId: '',
                    CURRPAGE: $scope.page.CURRPAGE,
                    PAGESIZE: $scope.page.PAGESIZE,
                    status: '',
                };
            }
            /**
             * [initData 初始化数据]
             * @return {[type]} [description]
             */
            function initData() {
                if (!$scope.status.id) return;
                $scope.params.tenantId = $scope.status.id;
                requestData();
            }
            /**
             * [requestData description]请求数据
             * @return {[type]} [description]
             */
            function requestData() {
                if ($scope.data.fromdate && $scope.data.untildate) {
                    $scope.params.startTime = $scope.data.fromdate;
                    $scope.params.endTime = $scope.data.untildate;
                } else {
                    delete $scope.params.startTime && delete $scope.params.endTime;
                }
                $scope.keywords === '' ? delete $scope.params.searchword : $scope.params.searchword = $scope.keywords;
                $scope.params.CURRPAGE = $scope.page.CURRPAGE;
                $scope.params.PAGESIZE = $scope.page.PAGESIZE;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                    $scope.data.items = angular.forEach(data.data.ldata, function(item, index) {
                        item.imgurl = thumbnail(item.picList);
                    });
                    $scope.page.ITEMCOUNT = data.data.totalResults;
                    $scope.page.PAGESIZE = data.data.pageSize;
                    $scope.data.selectedArray = [];
                });
            }

            /**
             * [queryByDropdown 下拉框操作]
             * @param  {[type]} params [description]
             * @param  {[type]} value  [description]
             * @return {[type]}        [description]
             */
            $scope.queryByDropdown = function(params, key) {
                $scope.params[params] = key.value;
                requestData();
            };

            /**
             * [querySearch 快速检索]
             * @return {[type]} [description]
             */
            $scope.querySearch = function(event) {
                if (!!event && event.keyCode == 13) {
                    requestData();
                } else if (!event) {
                    requestData();
                }
            };

            /**
             * [thumbnail 格式化缩略图]
             * @param  {[type]} imgList [description]
             * @return {[type]}         [description]
             */
            function thumbnail(imgList) {
                var list = JSON.parse(imgList);
                if (list.length > 0) {
                    for (var i = 0; i < list.length; i++) {
                        list[i].PICSLOGO = list[i].appfile;
                    }
                }
                return list;
            }

            /**
             * [withdraw 撤回]
             * @return {[type]} [description]
             */
            $scope.withdraw = function(item) {
                let hasWithdraw = false;
                if (angular.isUndefined(item)) {
                    hasWithdraw = $scope.data.selectedArray.some((docItem) => {
                        return docItem.status == 1;
                    });
                }
                if (hasWithdraw) {
                    modalDialog.alertType('', '选择列表中包含已经撤稿的稿件，请重新选择', 'warning', 'confirm');
                } else {
                    modalDialog.alertType('', '所有选中稿件将被撤回，确定继续？', 'ask', true, function() {
                        var params = {
                            serviceid: "mlf_PluralisticShare",
                            methodname: "shareListWithdraw",
                            dataIds: item ? item.id : trsspliceString.spliceString($scope.data.selectedArray, 'id', ','),
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                            if (data.success == true) {
                                modalDialog.alertType('', '撤稿成功', 'success', false, function() {
                                    requestData();
                                });
                            }
                        });
                    }, function() {
                        return;
                    });
                }
            };

            /**
             * [queryByTime 根据时间查询]
             * @return {[type]} [description]
             */
            $scope.queryByTime = function() {
                requestData();
            };

            /**
             * [getTenentShareRecord description] 获取租户分享稿件记录
             * @return {[type]} [description]
             */
            $scope.getTenentShareRecord = function(item) {
                resCtrModalService.tenantShareManuRecord(item).then(function() {});
            };
            /**
             * [selectAll description] 列表全选按钮
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            };
            /**
             * [selectDoc description] 列表单选按钮
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.selectDoc = function(item) {
                var index = $scope.data.selectedArray.indexOf(item);
                if (index < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice(index, 1);
                }
            };
            /** [selectPageNum description] 每页显示的数据数量
             */
            $scope.selectPageNum = function() {
                $scope.status.copyCurrPage = 1;
                requestData();
            };
            /**
             * [pageChanged description] 下一页 页面改变调取数据
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };
            /**
             * [jumpToPage description] 跳转页
             * @return {[type]} [description]
             */
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            };

            /**
             * [getType 获取稿件类型名字]
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            $scope.getType = function(type) {
                var typeName = $scope.iWoDocStatusName.filter(function(item) {
                    return item.value == type;
                })[0];
                return typeName.name;
            };

            $scope.tenantManuscriptPreview = function(item) {
                storageListenerService.previewPageTurningStorage($scope.data.items, "id,srcId", 'tenantManuscriptPreview');
            };
        }
    ]);